// import { LitElement } from 'lit';
// import { EventEmitter } from '@converse/headless';

// export class CustomElement extends EventEmitter(LitElement) {
//     constructor() {
//         super();
//     }

//     createRenderRoot() {
//         // Render without the shadow DOM
//         return this;
//     }

//     initialize() {
//         return null;
//     }

//     connectedCallback() {
//         super.connectedCallback();
//         return this.initialize();
//     }

//     disconnectedCallback() {
//         super.disconnectedCallback();
//         this.stopListening();
//     }
// }
import { LitElement } from 'lit';
// Змінюємо імпорт з '@converse/headless' на '@converse/skeletor'
import { EventEmitter } from '@converse/skeletor';

export class CustomElement extends EventEmitter(LitElement) {
    constructor() {
        super();
    }

    createRenderRoot() {
        // Render without the shadow DOM
        return this;
    }

    initialize() {
        return null;
    }

    connectedCallback() {
        super.connectedCallback();
        return this.initialize();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        // Переконуємося, що метод існує перед викликом (безпечне відключення слухачів подій)
        if (typeof this.stopListening === 'function') {
            this.stopListening();
        }
    }
}
